import React from 'react';

var ListPlus = React.createClass({
  handleClick: function(){
    alert("coming soon");
  },
  render: function(){
    return(
         <article className="theme-list add-button clearfix"> 
              <span className="plus__icon">
                 <i className="fa  fa-plus"> </i> 
              </span>
              <div className="theme-list--overlay"></div>
              <div className="theme-list__actions">
                <div className="links add-new__theme" onClick = {this.handleClick}><a href="javascript:void(0)">Add a New Theme</a></div>
                {/*<div className="links from__marketplace"><a href="javascript:void(0)">From the Marketplace</a></div>
                <div className="links from__scratch"><a href="javascript:void(0)">Build From Scratch</a></div>
                <div className="links upload__install"><a href="javascript:void(0)">Upload &amp; Install</a></div>*/}
              </div>
          </article>
    );
  }
});

export {ListPlus};


/** WEBPACK FOOTER **
 ** ./html/components/ListPlus.jsx
 **/